import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950">
          准备好开始阅读了吗？
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
          下拉式流畅阅读体验，数千部精彩韩漫等你来发现
        </p>
        <Link
          to="/category/all"
          className="inline-flex items-center gap-2 mt-8 px-10 py-3.5 bg-primary-600 text-background-50 font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-700 transition-colors duration-200 text-sm"
        >
          立即免费阅读 <i className="ri-arrow-right-line"></i>
        </Link>

        <div className="mt-12">
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
            {[
              { icon: 'ri-smartphone-line', label: '手机阅读' },
              { icon: 'ri-computer-line', label: '电脑阅读' },
              { icon: 'ri-tablet-line', label: '平板阅读' },
              { icon: 'ri-download-line', label: '离线缓存' },
              { icon: 'ri-bookmark-line', label: '收藏书签' },
            ].map((item) => (
              <div key={item.label} className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-background-100 text-foreground-600">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <span className="text-xs text-foreground-500">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}